import { DirectoryProtectionListProps } from "./DirectoryProtectionListItem";
import { Action } from "@mittwald/flow-remote-react-components";
import { Text } from "@mittwald/flow-remote-react-components";
import { Content } from "@mittwald/flow-remote-react-components";
import { Heading } from "@mittwald/flow-remote-react-components";
import { Modal } from "@mittwald/flow-remote-react-components";
import { Section } from "@mittwald/flow-remote-react-components";
import { Label } from "@mittwald/flow-remote-react-components";
import { ActionGroup } from "@mittwald/flow-remote-react-components";
import { Button } from "@mittwald/flow-remote-react-components";
import { SubmitHandler, useForm } from "react-hook-form";
import {
  Form,
  typedField,
} from "@mittwald/flow-remote-react-components/react-hook-form";
import { useEffect, useState } from "react";
import { CreateUserError } from "../../errors/CreateUserError";
import { OverlayController } from "@mittwald/flow-remote-react-components";
import { useDeclareDirectoryProtection } from "../../hooks/useDeclareDirectoryProtection";
import { CheckboxGroup } from "@mittwald/flow-remote-react-components";
import { CheckboxButton } from "@mittwald/flow-remote-react-components";
import { useListUsers } from "../../hooks/useListUsers";

interface FormInputs {
  users: string[];
}

export const ChangeUsersDirectoryProtectionModal = (props: {
  projectId: string;
  directoryProtection: DirectoryProtectionListProps;
  controller: OverlayController;
}) => {
  const { controller } = props;

  const [errorOnSubmit, setErrorOnSubmit] = useState<Error | undefined>(
    undefined,
  );

  if (errorOnSubmit) {
    throw errorOnSubmit;
  }

  const users = useListUsers(props.projectId);
  const existingUsernames = users.data.map((u) => u.username);

  const form = useForm<FormInputs>({
    defaultValues: {
      users: props.directoryProtection.users
        .map((u) => u.username)
        .filter((u) => existingUsernames.includes(u)),
    },
  });

  // Registered in an effect so the handler is added once and removed on
  // unmount (addOnClose returns the disposer).
  useEffect(
    () =>
      controller.addOnClose(() => {
        form.reset();
      }),
    [controller, form],
  );

  const declareDirectoryProtectionMutation = useDeclareDirectoryProtection(
    props.projectId,
  );

  const onSubmit: SubmitHandler<FormInputs> = async (data) => {
    const result = await declareDirectoryProtectionMutation.mutateAsync({
      description: props.directoryProtection.description,
      path: props.directoryProtection.path,
      users: data.users,
      appInstallationId: props.directoryProtection.appInstallationId,
    });

    if (result.error) {
      setErrorOnSubmit(new CreateUserError(result.error.message));
    }

    form.reset(data);
    controller.close();
  };

  const Field = typedField(form);

  return (
    <Modal controller={controller}>
      <Form form={form} onSubmit={onSubmit}>
        <Heading>
          <Text>Benutzer anpassen</Text>
        </Heading>
        <Content>
          <Section>
            <Text>
              Dein Passwortschutz kann für einen bzw. mehrere Benutzer
              freigeschaltet werden.
            </Text>

            <Field
              name="users"
              rules={{ required: "Bitte wähle mindestens einen Benutzer aus" }}
            >
              <CheckboxGroup isRequired>
                <Label>Benutzer auswählen</Label>
                {users.data.map((u) => (
                  <CheckboxButton key={u.username} value={u.username}>
                    {u.username}
                  </CheckboxButton>
                ))}
              </CheckboxGroup>
            </Field>
          </Section>
        </Content>
        <ActionGroup>
          <Button
            color="success"
            type="submit"
            isPending={declareDirectoryProtectionMutation.isPending}
            isSucceeded={declareDirectoryProtectionMutation.isSuccess}
          >
            Benutzer speichern
          </Button>
          <Action
            onAction={() => {
              controller.close();
            }}
          >
            <Button color="secondary" variant="soft">
              Abbrechen
            </Button>
          </Action>
        </ActionGroup>
      </Form>
    </Modal>
  );
};
